<template>
  <form
    class="simple-create-form"
    @submit.prevent="submitForm"
  >
    <h3>
      Opret ny bruger
    </h3>
    <Box>
      <BaseInput
        label="E-mail"
        placeholder="mail@example.com"
        v-model="form.email"
        :disabled="loading"
      />
      <BaseInput
        label="Password"
        placeholder="******"
        type="password"
        v-model="form.password"
        :disabled="loading"
      />
      <BaseFormField label="Rolle">
        <BaseSelect
          label="name"
          :placeholder="form.isAdministrator | IsAdmin"
          @select="updateIsAdministrator"
          :options="[{value: true, name: 'Administrator'}, {value: false, name: 'Bruger'}]"
          :disabled="loading"
        />
      </BaseFormField>
      <div class="simple-create-form__inline">
        <BaseButton
          label="Opret ny bruger"
          :disabled="loading || $v.$invalid"
        />
        <div>
          <BaseSpinner
            height="40px"
            width="40px"
            v-if="loading"
          />
        </div>
      </div>
    </Box>
  </form>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators';
import BaseSelect from '../../BaseSelect.vue';
import BaseFormField from '../../BaseFormField.vue';
import BaseSpinner from '../../BaseSpinner.vue';
import BaseButton from '../../BaseButton.vue';
import Box from '../../Box.vue';
import BaseInput from '../../BaseInput.vue';
import UserService from '../../../services/UserService';
import IsAdmin from '../../../filters/IsAdmin';

export default {
    name: 'CreateUserForm',
    components: {
        BaseInput, Box, BaseButton, BaseSpinner, BaseFormField, BaseSelect,
    },
    filters: { IsAdmin },
    data() {
        return {
            loading: false,
            form: {
                email: '',
                password: '',
                isAdministrator: false,
            },
        };
    },
    validations: {
        form: {
            email: { required, email },
            password: { required },
        },
    },
    methods: {
        resetForm() {
            this.form.email = '';
            this.form.password = '';
            this.form.isAdministrator = false;
        },
        updateIsAdministrator(e) {
            this.form.isAdministrator = e.value;
        },
        async submitForm() {
            this.$v.$touch();

            if (this.$v.$invalid) {
                this.$snotify.error('Ikke alle felter er udfyldt korrekt.');
                return;
            }

            try {
                this.loading = true;

                const payload = await UserService.create(this.form);

                this.$snotify.success(`${payload.email} er oprettet`);
                this.loading = false;
                this.$emit('created', payload);
                this.resetForm();
            } catch (error) {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.simple-create-form {
    max-width: 500px;
    margin-top: 50px;

    &__inline {
        display: flex;

        svg {
            margin-left: 10px;
        }
    }
}
</style>
